import { navy } from '@zocdoc/branding/colors';
import { kievitSlabBook } from '@zocdoc/components/src/typography';
import styled from 'styled-components';

const ListItem = styled.li`
    ${kievitSlabBook(20, 28)}
    color: ${navy};
    padding-top: 2px;

    &:first-of-type {
        padding-top: 0;
    }
`;

export default ListItem;
